import { WorkflowTriggerType } from '@commenda/types';
import { Icons } from '@commenda/kakashi';
import { cn } from '@commenda/utils';
import { Handle, Position } from '@xyflow/react';
import { TTriggerNodeProps } from '../types/node';
import { SOURCE_HANDLE_CLASSNAME } from './helpers';
import { WorkflowHandlerID } from '../../workflow/ui';

const TRIGGER_LABELS: Record<WorkflowTriggerType, string> = {
  [WorkflowTriggerType.MANUAL]: 'Manual Trigger',
  [WorkflowTriggerType.INTERNAL_EVENT]: 'App Event',
};

export const TriggerNode = ({ data, selected }: TTriggerNodeProps) => {
  const label = TRIGGER_LABELS[data.triggerType] ?? 'Trigger';

  return (
    <div
      className={cn(
        'px-2 py-2 pr-5 rounded-md border bg-white',
        selected ? 'border-accent-blue-100' : 'border-stroke-3',
      )}
    >
      <div className="text-xs flex gap-2">
        <div>
          <div className="p-2 bg-bg-purple-hover rounded-md">
            <Icons.Zap className="size-4" />
          </div>
        </div>
        <div className="flex flex-col flex-1">
          <span className="txt-extra-small-regular">{label}</span>
          <span className="txt-medium-medium">{data.name}</span>
          {data.triggerType === WorkflowTriggerType.INTERNAL_EVENT &&
            data.eventType && (
              <span className="txt-extra-small-regular text-text-secondary mt-0.5">
                {data.eventType}
              </span>
            )}
        </div>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        className={SOURCE_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.SOURCE_RIGHT}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        className={SOURCE_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.SOURCE_BOTTOM}
      />
    </div>
  );
};
